import BasicTablesCntainer from "../../Componant/BootstrapTables/BasicTables";

const BasicTables = () => {
  return (
    <div className="page-body">
      <BasicTablesCntainer />
    </div>
  );
};

export default BasicTables;
